export interface GameplayDiagnostics {
  readonly platform: string;
  readonly 'audioContext.state': string;
  readonly audioStartRequested: boolean;
  readonly audioSourceStarted: boolean;
  readonly audioCurrentTime: number;
  readonly gain: number;
  /** Graph gain only: hardware mute / speaker routing is not exposed to JS. */
  readonly muted: boolean;
  readonly audioError: string | null;
  readonly audioSessionType: string;
  readonly demoPreloaded: boolean;
  readonly outputSignalPeak: number;
  readonly audioState: string;
  readonly playbackTime: number;
  readonly schedulerStarted: boolean;
  readonly chartLoaded: boolean;
  readonly currentNoteIndex: number;
  readonly spawnedNotes: number;
  readonly viewportWidth: number;
  readonly viewportHeight: number;
  readonly DPR: number;
  readonly orientation: string;
  readonly updateCount: number;
  readonly frameCount: number;
  readonly renderedNotes: number;
}

/** Dev ?debug=1, or explicit production ?audioDebug=1 for device diagnosis. */
export class GameplayDiagnosticsPanel {
  private readonly element: HTMLPreElement;
  constructor(parent = document.body) {
    this.element = document.createElement('pre');
    this.element.className = 'mandalizm-gameplay-diagnostics';
    this.element.style.cssText = 'position:fixed;z-index:85;top:8px;left:8px;max-width:calc(100vw - 32px);' +
      'max-height:40dvh;overflow:auto;white-space:pre-wrap;pointer-events:none;margin:0;padding:8px;' +
      'font:10px/1.3 monospace;color:#bcfff0;background:rgba(0,8,14,.9);';
    parent.append(this.element);
  }
  update(values: GameplayDiagnostics): void {
    this.element.textContent = Object.entries(values).map(([key, value]) =>
      `${key}: ${key === 'playbackTime' ? Number(value).toFixed(3) : String(value)}`).join('\n');
  }
  dispose(): void { this.element.remove(); }
}
